<template>
    <div class="application-index">
        <!--banner-->
        <div class="application">
            <banHead :bannerHead="banHead"></banHead>
        </div>
        <!--content-->
        <section>
            <!--content1-->
            <div class="app-cont">
                <div class="monitor-cont center">
                    <img src="/static/image/application/Environmental-Monitoring@1x.jpg" _src="/static/image/application/Environmental-Monitoring@2x.jpg" alt="">
                    <div class="monitor-mes">
                        <h1 class="common-font">Environmental Monitoring</h1>
                        <message :detailMsg="appCont1"></message>
                        <message :detailMsg="appCont2"></message>
                        <message :detailMsg="appCont3"></message>
                    </div>
                </div>
            </div>
            <!--content2-->
            <div class="location-cont" _src="/static/image/application/Location-Service@2x.jpg">
                <div class="location center">
                    <div class="location-mes">
                        <h1 class="common-font">Location Service</h1>
                        <message :detailMsg="locationCont1"></message>
                        <message :detailMsg="locationCont2"></message>
                        <message :detailMsg="locationCont3"></message>
                    </div>
                    <img src="/static/image/application/dingwei@1x.png" _src="/static/image/application/dingwei@2x.png" alt="">
                </div>
            </div>
            <!--content3-->
            <div class="digital-cont">
                <div class="digital center">
                    <div class="digital-mes">
                        <div class="digital-left">
                            <img src="/static/image/application/changjing@1x.jpg" _src="/static/image/application/changjing@2x.jpg" alt="">
                            <h1 class="common-font">Smart Home</h1>
                            <div class="digital-pro">
                                <message :detailMsg="smartSafe"></message>
                                <message :detailMsg="smartGas"></message>
                            </div>

                        </div>
                        <div class="digital-right">
                            <img src="/static/image/application/Digital-Marketing@1x.jpg" _src="/static/image/application/Digital-Marketing@2x.jpg" alt="">
                            <h1 class="common-font">Digital Marketing</h1>
                            <div class="digital-pro">
                                <message :detailMsg="digitalMarket"></message>
                                <message :detailMsg="digitalData"></message>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import banHead from '../common/banHead';
    import message from '../common/message'

    export default {
        name: "application",
        data() {
            return {
                banHead: {
                    title: 'Application Scenarios',
                    msg: 'In the Internet of Things era, we believe in the use of low-power sensors, and ultra-low-power communications technologies to help the building smart businesses and cities.',
                    _src:'/static/image/application/Application-Scenarios-banner@2x.jpg'
                },
                appCont1: {
                    title: 'Temperature and Humidity Control',
                    msg: 'Monitoring equipment and facilities that are sensitive to temperature and humidity.'
                },
                appCont2: {
                    title: 'Light Monitoring',
                    msg: 'Conducting ambient light monitoring and control.'
                },
                appCont3: {
                    title: 'Gas Monitoring',
                    msg: 'Cold chain temperature monitoring to prevent the deterioration of goods during transportation or storage.'
                },
                locationCont1: {
                    title: 'Cold Chain Status',
                    msg: 'Cold chain temperature monitoring to prevent the deterioration of goods during transportation or storage.'
                },
                locationCont2: {
                    title: 'Route Management',
                    msg: 'Facilitating vehicle dispatching,enabling the optimization and design of new transport routes and networks in cities.'
                },
                locationCont3: {
                    title: 'Container Position Tracking',
                    msg: 'Providing temperature, humidity and gas monitoring to check on shipping conditions as well as light monitoring to know whether containers have been opened.'
                },
                smartSafe: {
                    title: 'Safety Monitoring',
                    msg: 'Monitoring doors and windows, setting off alarms remotely and enabling the access to smart home devices through an app.'
                },
                smartGas: {
                    title: 'Gas and Leak Detection',
                    msg: 'Detecting changes in gas concentration, leaks and implementing prevention alarms.'
                },
                digitalMarket: {
                    title: 'Push marketing',
                    msg: 'Creation of smart areas where users’ can receive the latest discounts, vouchers and events’ information, boosting sales and raising brand awareness.'
                },
                digitalData: {
                    title: 'Data Collection',
                    msg: 'Collection of highly valuable information for marketing campaigns. '
                }

            }
        },

        watch:{


        },
        mounted(){
            // var _this = this
            // let imgs = document.querySelectorAll('img')
            // console.log(imgs)
            // Array.from(imgs).forEach((item)=>{
            //     let img = new Image()
            //     img.onload = ()=>{
            //
            //     }
            //     img.src=item.getAttribute('_src')
            // })
            this.utils.getImg()
            // console.log(this);

        },
        methods:{
        },
        components: {
            banHead,
            message
        }
    }
</script>

<style lang="less">
    .application-index {
        width:100%;
        @baseWidth: 1640px;
        .center {
            width: @baseWidth;
            margin: 0 auto;
        }
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        h2 {
            font-size: 24px;
            color: #252525;
            line-height: 24px;
        }

        p {
            font-size: 16px;
            color: #5D5D5D;
            line-height: 26px;
        }
        /*banner*/
        .application {
            width: 100%;
            .com-banner {
                background: url("/static/image/application/Application-Scenarios-banner@1x.jpg") no-repeat center;
                background-size: cover;
                p {
                    width: 750px;
                    color: #fff;
                }
            }
        }
        section {
            h1 {
                font-size: 28px;
                color: #252525;
                line-height: 36px;
                margin-bottom: 40px;
            }
            h2 {
                font-size: 20px;
                line-height: 24px;
                margin-bottom: 8px;
            }
            p {
                margin-bottom: 32px;

            }
            /*content1*/

            .app-cont {
                margin: 72px auto 112px;
                height: 100%;
            }
            .monitor-cont {
                display: flex;
                justify-content: space-between;
                height: 100%;
                img {
                    display: block;
                    width: 640px;
                    height: 100%;
                    object-fit: contain ;
                }
                .monitor-mes {
                    width: 50%;
                    padding-top: 120px;
                    /*margin-left: 100px;*/
                    p {
                        margin-right: 280px;

                    }
                }
            }

            /*content2*/
            .location-cont {
                background: url("/static/image/application/Location-Service@1x.jpg") no-repeat center;
                background-size: cover;
                margin-bottom: 132px;
                .location {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .location-mes {
                        margin-bottom: 100px;
                        padding-left: 140px;
                        h1 {
                            margin-top: 109px;
                        }
                        p {
                            width: 57%;
                        }

                    }
                    img {
                        /*margin-bottom: 30px;*/
                        margin-right: 100px;
                        width: 612px;
                        /*height: 385px;*/
                    }
                }
            }
            /*content3*/
            .digital-cont {
                margin-bottom: 114px;
                height: 100%;
                .digital-mes {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: space-between;
                    img {
                        display: block;
                        width: 100%;
                        /*height: 100%;*/
                    }
                    h1 {
                        margin: 48px 0 32px;
                        line-height: 54px;
                    }
                    h2 {
                        margin-bottom: 16px;
                    }
                    .digital-left {
                        width: 800px;
                        height: 100%;
                        margin-right: 40px;
                    }
                    .digital-pro {
                        display: flex;
                        /*width: 25%;*/
                        justify-content: space-between;
                        p {
                            width: 380px;
                        }
                    }
                    .digital-right {
                        width: 800px;
                        height: 100%;
                        margin-right: 40px;
                    }
                }
            }
        }

    }

    @media screen and (max-width: 1680px){
        @baseWidth: 1216px;
        @autoWidth:1256px;
        .application-index {
            width: 100%;
            min-width: @autoWidth;
            .center {
                width: @baseWidth;
                margin: 0 auto;
            }
            section {
                .monitor-cont {
                    display: flex;
                    justify-content: space-between;
                    height: 100%;
                    img {
                        display: block;
                        width: 50%;
                    }
                    .monitor-mes {
                        margin-left: 150px;
                        p {
                            margin-right: 0;

                        }
                    }
                }
                .location-cont {
                    .location {
                        .location-mes {
                            margin-bottom: 100px;
                            padding-left: 0;
                            margin-right: 50px;
                            h1 {
                                margin-top: 109px;
                            }
                            p {
                                width: 460px;
                            }

                        }
                        img {
                            margin-top: 130px;
                            margin-right: 0;

                        }
                    }
                }
                .digital-cont {
                    .digital-mes {
                        img {
                            display: block;
                            width: 590px;
                        }
                        .digital-pro {
                            justify-content: inherit;
                            p {
                                width: 230px;
                            }
                            .news-detail:nth-child(1){
                                margin-right: 80px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/application.vue